import React from 'react';

import './oppsummering.scss';

export const OppsummeringFooter = () => {
    return (
        <div className="oppsummering-footer">
            <p>
                Når vi behandler skadesaken din, bruker vi personopplysninger om deg. Vi behandler opplysninger om deg
                og klagesaken konfidensielt, som bestemt i Lov om personopplysninger.{' '}
                <a href="https://www.fremtind.no/personvern" target="_blank" rel="noopener noreferrer">
                    Les mer om personvern her
                </a>
                .
            </p>

            <p>
                Vi stoler på deg, og at du gir oss så riktige og fullstendige opplysninger du kan. Kunder som holder
                tilbake eller oppgir uriktige opplysninger kan miste retten til erstatning.
            </p>
        </div>
    );
};
